<template>
  <div class="b-double-datepicker">
    <span
      v-show="!openDatepickers"
      class="b-double-datepicker__button"
      @click="toggleDatepickers">
      {{ label }}
    </span>

    <div v-show="openDatepickers" class="b-double-datepicker__wrap">
      <div class="b-double-datepicker__pickers">
        <div class="b-double-datepicker__from">
          <span class="icon-calendar"></span>
          <span class="b-double-datepicker__label">{{ fromLabel }}</span>
          <input
            ref="inputFrom"
            type="text"
            readonly
            class="input date-input"
            autocomplete="off" />
        </div>
        <div class="b-double-datepicker__to">
          <span class="icon-calendar"></span>
          <span class="b-double-datepicker__label">{{ toLabel }}</span>
          <input
            ref="inputTo"
            type="text"
            readonly
            class="input date-input"
            autocomplete="off" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Datepicker } from 'jquery-ui/ui/widgets/datepicker'

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    fromLabel: {
      type: String,
      default: '',
    },
    toLabel: {
      type: String,
      default: '',
    },
    dateFrom: {
      type: String,
      default: '',
    },
    dateTo: {
      type: String,
      default: '',
    },
    reInitPickers: {
      required: true,
      type: Boolean,
    },
  },
  emits:['changed-date'],
  data() {
    return {
      inputFrom: null,
      inputTo: null,
      openDatepickers: false,
      valid: true,
    }
  },
  watch: {
    reInitPickers(newVal) {
      if (newVal) {
        this.reset()
      }
    },
  },
  mounted() {
    this.inputFrom = jQuery(this.$refs.inputFrom)
    this.inputTo = jQuery(this.$refs.inputTo)

    this.$nextTick(function () {
      this.iniDatepicker()
    })
  },

  methods: {
    iniDatepicker() {
      this.inputFrom.datepicker({
        minDate: new Date(this.dateFrom),
        maxDate: new Date(this.dateTo),
        dateFormat: 'dd/mm/yy',
        onSelect: () => {
          this.setMinDate()

          this.checkToPostData()

          setTimeout(() => {
            if (this.inputTo.val() === '') {
              this.inputTo.datepicker('show')
            }
          })
        },
      })

      this.inputTo.datepicker({
        minDate: new Date(this.dateFrom),
        maxDate: new Date(this.dateTo),
        dateFormat: 'dd/mm/yy',
        // changeYear: true,
        onSelect: () => {
          this.setMaxDate()

          this.checkToPostData()

          setTimeout(() => {
            if (this.inputFrom.val() === '') {
              this.inputFrom.datepicker('show')
            }
          })
        },
      })
    },

    setMinDate() {
      const currentDate = this.inputFrom.datepicker('getDate')
      this.inputTo.datepicker('option', 'minDate', currentDate)
    },
    setMaxDate() {
      const currentDate = this.inputTo.datepicker('getDate')
      this.inputFrom.datepicker('option', 'maxDate', currentDate)
    },

    formattedDate(today) {
      const yyyy = today.getFullYear()
      let mm = today.getMonth() + 1
      let dd = today.getDate()
      if (dd < 10) dd = '0' + dd
      if (mm < 10) mm = '0' + mm
      return yyyy + '-' + mm + '-' + dd
    },

    checkToPostData() {
      this.valid = this.isValid()

      if (this.valid) {
        jQuery('.b-double-datepicker').addClass('b-double-datepicker--active')

        this.$emit('changed-date', {
          from: this.formattedDate(this.inputFrom.datepicker('getDate')),
          to: this.formattedDate(this.inputTo.datepicker('getDate')),
        })
      }
    },

    isValid() {
      if (this.inputFrom && this.inputTo) {
        return this.inputFrom.val() !== '' && this.inputTo.val() !== ''
      }
      return true
    },

    toggleDatepickers() {
      this.openDatepickers = !this.openDatepickers
    },
    reset() {
      this.inputFrom.datepicker('setDate', null).val('')
      this.inputTo.datepicker('setDate', null).val('')
      jQuery('.b-double-datepicker').removeClass('b-double-datepicker--active')
      this.openDatepickers = false
    },
  },
}
</script>
